import type { ComponentProps } from "react";
import { Button, Icon } from "~components/ui";
import { useOrderEventsContext } from "./order-events-context-provider";
import { useSectionEventTranslations } from "./translations-section-events-context-provider";

function EventsOrder() {
  const { t } = useSectionEventTranslations();
  const { toggleSortOrder, sortOrder } = useOrderEventsContext();

  const isAsc = sortOrder === "asc";

  const iconName: ComponentProps<typeof Icon>["name"] = isAsc
    ? "SortAscending"
    : "SortDescending";

  const currentLabel = isAsc ? t.sortOldest : t.sortNewest;
  const nextLabel = isAsc ? t.sortNewest : t.sortOldest;

  return (
    <Button
      variant="secondary"
      className="max-h-max max-w-max shrink-0"
      onClick={toggleSortOrder}
      aria-label={nextLabel}
    >
      <Icon name={iconName} size="24" />
      <span className="sm:inline-flex">{currentLabel}</span>
    </Button>
  );
}

export { EventsOrder };
